module.exports = __webpack_public_path__ + "img/7.995113c2.png";